import React from 'react'
import Phone from 'components/shared/Phone'
import styled from 'styled-components'
import IntroIllustrationDesc from './shopifyUI/IntroIllustrationDesc'
import {Wrapper, PhoneContainer, CenteredLayer, EditorWrapper, EditorContainer} from './ShopifyWizardIllustration'
import {Spinner} from '@shopify/polaris'

const SpinnerWrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

const WizardSkeleton = () => (
  <Wrapper>
    <PhoneContainer>
      <CenteredLayer>
        <Phone needOffset={false} wrapperRawStyle='z-index: 10'>
          <SpinnerWrapper>
            <Spinner size='small' accessibilityLabel='Loading' />
          </SpinnerWrapper>
        </Phone>
      </CenteredLayer>
    </PhoneContainer>
    <EditorWrapper>
      <EditorContainer>
        <IntroIllustrationDesc isLoading />
      </EditorContainer>
    </EditorWrapper>
  </Wrapper>
)

export default WizardSkeleton



// WEBPACK FOOTER //
// ./src/components/shopifyApp/shopifyWizard/Skeleton.js